import {
	Component,
	Input,
	ElementRef,
	OnInit,
	OnDestroy,
	Output,
	EventEmitter
} from '@angular/core';
import { WritingToolsService } from './writing-tools.service';
import { WritingTool, Language, Tone, WritingToolsDto } from '../../../../../../api/src/integrations/vml-openai-gateway/vml-openai-gateway.dto';
import { Subscription } from 'rxjs';
import { materialModules } from '../../../angular-material.module';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-writing-tools',
	templateUrl: './writing-tools.component.html',
	styleUrls: ['./writing-tools.component.scss'],
	imports: [
		CommonModule,
		...materialModules
	],
	standalone: true
})
export class WritingToolsComponent implements OnInit, OnDestroy {
	@Input() enabledTools: Partial<Record<WritingTool, boolean>> = {
		[WritingTool.Translate]: true,
		[WritingTool.ChangeTone]: true,
		[WritingTool.Simplify]: true,
		[WritingTool.Summarize]: true,
		[WritingTool.Expand]: true,
		[WritingTool.FixSpellingGrammar]: true
	};
	@Input() translateLanguages = Object.values(Language);
	@Input() toneOptions = Object.values(Tone);
	@Input() value!: string;

	@Output() valueChanged = new EventEmitter<string>();

	public WritingTool = WritingTool;
	public tools: string[] = [];
	private subs = new Subscription();
	loading: boolean = false; // Add loading state

	constructor(private svc: WritingToolsService) {}

	ngOnInit() {
		// Translate enabled tools into the tools array.
		this.tools = Object.keys(this.enabledTools)
			.filter(tool => this.enabledTools[tool])
			.map(tool => tool as keyof typeof WritingTool);
	}

	ngOnDestroy() {
		this.subs.unsubscribe();
	}

	onSelect(tool: WritingTool, option?: Language | Tone) {
		if (tool === WritingTool.Translate || tool === WritingTool.ChangeTone) {
			// Handle nested selection for Translate or Change Tone
			let extraMetadata = {};
			if (tool === WritingTool.Translate) {
				extraMetadata = { language: option };
			} else if (tool === WritingTool.ChangeTone) {
				extraMetadata = { tone: option };
			}

			this.callService({
				tool,
				input: this.value,
				...extraMetadata
			});
			return;
		}

		// Simple tools
		this.callService({ tool, input: this.value });
	}

	private callService(dto: WritingToolsDto) {
		this.loading = true; // Set loading to true before the service call
		this.subs.add(
			this.svc.applyTool(dto).subscribe(
				(res) => {
					console.log('Writing tool applied:', res);
					this.valueChanged.emit(res.data);
					this.loading = false; // Reset loading state on success
				},
				(err) => {
					console.warn('Error applying writing tool:', err);
					this.loading = false; // Reset loading state on error
				}
			)
		);
	}
}
